import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import SkillDetailContainer from '../../containers/SkillDetail';
import i18n from '../../resources/i18n';
const SkillDetail: React.SFC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('SkillDetail_0040')} />
			<SkillDetailContainer {...props} />
		</>
	);
};

export default SkillDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/SkillDetail.tsx